import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Grid } from "@mui/material";
import { PORTFOLIO_TRADE_TABLE_HEADERS } from "../constants";
import PortfolioTradeBox from "./Components/PortfolioTradeBox";
import Table from "components/Table";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import WrapperAverageBuy from "./Components/WrapperAverageBuy";
import WrapperAverageSell from "./Components/WrapperAverageSell";
import WrapperMarketPrice from "./Components/WrapperMarketPrice";
import WrapperValueBalance from "./Components/WrapperValueBalance";
import { formatDateToJalali } from "utils/helpers/time";
import { getPortfolioTradeAvgList } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";
import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { useMemo } from "react";

function PortfolioTradeTable() {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const portfolioChartForm = useSelector((state) => state.portfolio?.portfolioChartForm?.data);
  const portfolioTradeList = useSelector(
    (state) => state.portfolio.portfolioTradeList?.data
  );

  const defaultPortfolioChartForm = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.find((l) => l?.id === portfolioChartForm?.portfolioChartFormDetailId), [portfolioChartForm])

  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const portfolioTab = +searchParams.get("portfolioTab") || defaultPortfolioChartForm?.portfolioId || 1;
  const basketTab = +searchParams.get("basketTab") || "";
  const portfolioDate = +searchParams.get("portfolioDate") || 0;
  const startDate = searchParams.get("startDate") || "";


  const formattedDataList = portfolioTradeList?.map((data) => {
    return {
      ...data,
      valueBalance: <WrapperValueBalance data={data} />,
      averageBuy: <WrapperAverageBuy data={data} />,
      averageSell: <WrapperAverageSell data={data} />,
      marketPrice: <WrapperMarketPrice data={data} />,
    };
  });

  const handleGetPortfolioDetails = async () => {
    setLoading(true);
    await dispatch(
      getPortfolioTradeAvgList({
        portfolioId: portfolioTab,
        basketId: basketTab,
        dateTypeId: portfolioDate,
        startDate: formatDateToJalali(startDate),
      })
    );
    setLoading(false);
  };

  useEffect(() => {
    handleGetPortfolioDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioDate, startDate, basketTab]);

  return (
    <Grid container mt={2}>
      <Grid item xs={12}>
        {isMobileView ? (
          <Grid container spacing={2}>
            {!loading ? (
              <>
                {portfolioTradeList?.map((portfolioTradeItem) => (
                  <Grid item xs={12}>
                    <PortfolioTradeBox
                      portfolioTradeItem={portfolioTradeItem}
                    />
                  </Grid>
                ))}
              </>
            ) : (
              <Grid item xs={12}>
                <CardSkeleton heightSize={170} />
                <CardSkeleton heightSize={170} />
                <CardSkeleton heightSize={170} />
              </Grid>
            )}
          </Grid>
        ) : (
          <>
            {!loading ? (
              <Table
                onRowClick={(e) =>
                  navigate(`/portfolio-details/${e?.id}/${portfolioTab}?basket=${basketTab}`)
                }
                headers={PORTFOLIO_TRADE_TABLE_HEADERS}
                items={formattedDataList}
              />
            ) : (
              <TableSkeleton />
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
}

export default PortfolioTradeTable;
